import { render, staticRenderFns } from "./RebuttalCalculationsHelp.vue?vue&type=template&id=0827f44a&scoped=true&"
import script from "./RebuttalCalculationsHelp.vue?vue&type=script&lang=js&"
export * from "./RebuttalCalculationsHelp.vue?vue&type=script&lang=js&"
import style0 from "./RebuttalCalculationsHelp.vue?vue&type=style&index=0&id=0827f44a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0827f44a",
  null
  
)

export default component.exports